import type { IntlShape } from 'react-intl';

/**
 * A server message in the visitor's language. Text the API already wrote is
 * shown as is; validation codes (`taken`, `blank`, …) get a sentence, and any
 * other snake_case code a general one rather than the raw symbol.
 */
export const getServerErrorText = (intl: IntlShape, message: string): string => {
  switch (message) {
    case 'taken':
      return intl.formatMessage({
        defaultMessage: 'This is already used by another account.',
        id: 'form_error_value_taken',
      });
    case 'blank':
      return intl.formatMessage({
        defaultMessage: 'Please fill this in.',
        id: 'form_error_value_blank',
      });
    case 'invalid':
    case 'inclusion':
      return intl.formatMessage({
        defaultMessage: 'Please check this value.',
        id: 'form_error_value_invalid',
      });
    case 'too_long':
      return intl.formatMessage({
        defaultMessage: 'This is too long.',
        id: 'form_error_value_too_long',
      });
    case 'too_short':
      return intl.formatMessage({
        defaultMessage: 'This is too short.',
        id: 'form_error_value_too_short',
      });
    default:
      return !/^[a-z_]+$/.test(message)
        ? message
        : intl.formatMessage({
            defaultMessage: 'We could not save this. Please try again or contact support.',
            id: 'form_error_unknown',
          });
  }
};
